import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
const ɵ0 = (createTranslateLoader);
export class DynamicSharedModule {
}
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
export { ɵ0 };
